module.exports = __webpack_public_path__ + "static/media/PlutoRegular.5bbcd4cf.eot";